module.exports = __webpack_public_path__ + "static/img/生物師資介紹.2a996b2b.png";